import React from "react";
import {
  Box,
  FormControl,
  TextField,
  FormControlLabel,
  Switch,
  Tooltip,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";

const Options = ({
  stem,
  setJobName,
  handleOptionsChange,
  saveJobOptions,
  jobOptionState,
  jobOptionDisabled,

  // NEW
  cgenffVersion,
  onCgenffVersionChange,
}) => {
  const saveNameChange = (e) => {
    setJobName(e.target.value !== null ? e.target.value : stem);
  };

  const renderSwitch = (name, label, description) => (
    <Tooltip placement="right-start" title={description}>
      <FormControlLabel
        control={
          <Switch
            name={name}
            checked={jobOptionState[name]}
            disabled={jobOptionDisabled}
            onChange={(e) => {
              handleOptionsChange(e);
              saveJobOptions(e);
            }}
          />
        }
        label={label}
      />
    </Tooltip>
  );

  const handleVersionChange = (evt) => {
    if (jobOptionDisabled) return;
    onCgenffVersionChange(evt.target.value);
  };

  return (
    <div>
      {/* Grey helper text block (top-right-ish within the right column) */}
      <Box sx={{ display: "flex", justifyContent: "center", mb: 5 }}>
        <Box
          sx={{
            backgroundColor: "#d8d5d5",
            color: "#222",
            p: 2,
            borderRadius: 1,
            maxWidth: 460,
          }}
        >
          <Typography variant="body1">
            Choose a CGenFF Version to generate the parameters with. Version 5.0 is the latest and recommended to
            use.{" "}
            <a href="https://doi.org/10.1021/acs.jctc.5c00046" target="_blank" rel="noopener noreferrer">
              Read the latest CGenFF paper
            </a>{" "}
            to learn more.
          </Typography>
        </Box>
      </Box>

      {/* Use Version selector */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 2,
          mb: 5,
        }}
      >
        <Typography
          sx={{ color: "red", fontWeight: 600, fontSize: 22 }}
        >
          Use Version:
        </Typography>

        <RadioGroup
          row
          name="cgenff-version"
          value={cgenffVersion}
          onChange={handleVersionChange}
          aria-label="CGenFF version"
        >
          <FormControlLabel
            value="4.6"
            disabled={jobOptionDisabled}
            control={
              <Radio
                sx={{
                  color: "red",
                  "&.Mui-checked": { color: "red" },
                }}
              />
            }
            label={<Typography sx={{ color: "red", fontWeight: 600, fontSize: 25 }}>4.6</Typography>}
            sx={{
              mr: 2,
              "& .MuiFormControlLabel-label": { color: "red" },
            }}
          />

          <FormControlLabel
            value="5.0"
            disabled={jobOptionDisabled}
            control={
              <Radio
                sx={{
                  color: "red",
                  "&.Mui-checked": { color: "red" },
                }}
              />
            }
            label={<Typography sx={{ color: "red", fontWeight: 600, fontSize: 25 }}>5.0</Typography>}
            sx={{
              "& .MuiFormControlLabel-label": { color: "red" },
            }}
          />
        </RadioGroup>
      </Box>

      <TextField
        type="text"
        label="Job Name"
        InputLabelProps={{ shrink: true }}
        placeholder={`Input a custom name or use ${stem} for job name`}
        name="customName"
        variant="outlined"
        size="small"
        fullWidth
        inputProps={{ maxLength: 50 }}
        onChange={(e) => saveNameChange(e)}
      />

      <FormControl margin="normal">
        {renderSwitch(
          "mol2out",
          "Output Mol2",
          "“Output Mol2” will generate a processed Mol2 file of the molecule after assigning your parameters. Atom names will be modified in accordance with CHARMM formatting."
        )}

        {renderSwitch(
          "warning",
          "Include Warnings",
          "“Include Warnings” will display any warning information for resulting from the CGenFF program execution."
        )}

        {renderSwitch("debug", "Include Debug Info", "“Include Debug Info” will display debugging information.")}

        {renderSwitch(
          "copyParams",
          "Copy Existing Params",
          "“Copy Existing Params” will copy existing CHARMM General Force Field parameters to the output."
        )}
      </FormControl>
    </div>
  );
};

export default Options;
